import React from 'react'
import classNames from 'classnames'
import { IconScrollArrow, IconWallColor, IconCross } from './components/icons'
import { WallColor } from './data/WallColors'
import './WallColorSelector.scss'
import { ResponsiveIconButton } from './components/ResponsiveIconButton'

interface Props {
  readonly wallColorOptions: readonly WallColor[]
  wallColor: string
  isExpanded: boolean
  setWallColor: (color: string) => void
  onClose: () => void
}

const WallColorSelector: React.FunctionComponent<Props> = ({
  isExpanded,
  wallColorOptions,
  wallColor,
  setWallColor,
  onClose
}) => {
  return (
    <div className={classNames('WallColorSelectorWrapper', { collapsed: !isExpanded })}>
      <div
        className="wallColorSelector"
        onClick={e => e.stopPropagation()}
      >
        <div className="wallColorDescription">
          <img src={IconWallColor} alt="" style={{ marginRight: '10px' }}/>
          <span style={{ flexGrow: 1 }}> Select your wall colour</span>
          <span className="scrollText">Scroll</span>
          <img src={IconScrollArrow} alt=""/>
        </div>
        <div className="wallColorSelectorSliderWrapper">
          <div className="wallColorSelectorSlider">
            {
              wallColorOptions.map(({ color }) => (
                <div
                  key={color}
                  className={classNames('option', { selected: color === wallColor })}
                  style={{
                    backgroundColor: color,
                  }}
                  onClick={() => setWallColor(color)}
                />
              ))
            }
          </div>
        </div>
        <div className="closeButtonContainer">
          <ResponsiveIconButton
            iconSrc={IconCross}
            iconSize={20}
            buttonStyle="blackLink"
            onClick={onClose}
            label="Close"
          />
        </div>
      </div>
    </div>
  )
}

export default WallColorSelector